// extracted by mini-css-extract-plugin
module.exports = {"delete-footer":"DrawerAlertFooter_delete-footer__rR2B0","footer":"DrawerAlertFooter_footer__DLT83","delete-alert":"DrawerAlertFooter_delete-alert__uw_qx"};